<template>
    <div>
        <div class="w">
            <div class="title">毛皮护理工具的发明</div>
    <div class="desc_container">
      <p class="article">
        <span>
            10多年来，一位专业的狗狗美容师一直在寻找一种高质量、可靠的工具来对付过多的毛发。在尝试了所有商业化的工具后，她意识到没有有效的工具存在，于是决定与她丈夫一起开发一个工具。他们共同创造了第一个也是迄今为止独一无二的工具，可以有效和方便地清除宠物身上松散的底毛。
            同时，FURminator®的脱毛工具已经成为市场上非常广泛、抢手和受欢迎的美容工具。
        </span>
      </p>
    </div>

    <div class="title">FURminator 富美内特产品线</div>
    <div class="desc_container">
      <p class="article">
        <span>
            除了脱毛护理工具外，FURminator还定期为其产品系列提供创新的、受专利保护的解决方案。为了全面满足宠物主人及爱宠的需求，FURminator不断扩大其祛毛梳、美容梳、宠物香波、
            美容护理产品的范围。因此，FURminator正在确立其作为市场上最大的美容解决方案供应商的地位。
        </span>
      </p>
    </div>

    <div class="title">年度最佳品牌</div>
    <div class="desc_container">
      <p class="article">
        <span>
            没有什么比FURminator在2017年6月21日于维也纳霍夫堡宫举行的著名的世界品牌奖上被评为年度品牌更能体现我们客户的赞赏和忠诚了。 FURminator引以为豪的是，在今年的全球奖类别中，它是 "毛皮护理产品--过量毛发解决方案 "
            类别中唯一的国际品牌代表。该奖项高度反映了消费者的判断，表彰了世界上一些最佳品牌的成就。
        </span>
      </p>
    </div>

    <div class="title">FURminator富美内特祛毛梳的特点</div>
    <div class="desc_container">
      <p class="article">
        <span>
            •获得专利的不锈钢祛毛边，可减少90%的脱毛。
        </span>
        <br><br>
        <span>
            •由欧美专业美容师设计为宠物量身定制的祛毛工具
        </span>
        <br><br>
        <span>
            •避免在猫和小动物体内形成毛球，且不会对宠物造成损伤。
        </span>
        <br><br>
        <span>
            •效果显著，受到欧美宠物美容师以及宠物饲主的一致好评
        </span>
        <br><br>
        <span>
            •只要按下富美内特®按钮，就可以在祛毛梳上把脱毛清理干净，十分方便。
        </span>
        <br><br>
        <span>
            •值得信赖，口碑极佳：全世界 的宠物美容师、兽医和宠物专家都推荐使用
        </span>
        <br><br>
        <span>
            •符合人体工程学的手柄让您用起来得心应手
        </span>
        <br><br>
        <span>
            •精益求精工艺，任何山寨无法模仿
        </span>
      </p>
    </div>

    <div class="title">祛毛工具说明</div>
    <div class="desc_container">
      <p class="article">
        <strong>
            • 祛毛是什么意思
        </strong>
        <br><br>
        <span>
            –通常而言，人们在谈论到处理宠物脱毛时，会用到“
            刷毛”和/或“梳毛”这样的词语，但是， “刷毛”和“梳毛”并不等同于“祛毛”；
        </span>
        <br><br>
        <span>
            –人们用毛刷和毛梳给宠物梳毛，清除里面的杂质，保持宠物的漂亮形象；
        </span>
        <br><br>
        <span>
            –使用祛毛工具，无需修剪或破坏宠物的表层毛，就能将其身上脱落的绒毛清理出来；
        </span>
        <br><br>
        <span>
            –虽然一般的宠物美容流程包含了这两个必需的步骤，但就处理脱毛而论，
            富美内特® 宠物祛毛工具的表现比任何毛刷、耙梳和毛梳更加出色。
        </span>
        <br><br>
        <strong>
            • 祛毛是一般的宠物美容流程中的一个重要环节，原因在于：
        </strong>
        <br><br>
        <span>
            –祛毛能够保持宠物良好的健康和卫生状况；
        </span>
        <br><br>
        <span>
            –对于猫和其它喜欢舔毛的小动物而言，减少毛球的形成；
        </span>
        <br><br>
        <span>
            –在祛毛的过程中，可以顺道对宠物进行全身检查；
        </span>
        <br><br>
        <span>
            –增强宠物和主人之间的感情。
        </span>
      </p>
    </div>

    <div class="title">常见问题</div>
    <div class="desc_container">
      <p class="article">
        <strong>
            一：富美内特梳子和其它梳子比较有哪些优点？
        </strong>
        <br><br>
        <span>
            答：富美内特梳子祛毛效果达到90%以上，减少居家环境毛发乱飞的状况，而普通梳子所不具备这种祛毛效果。
        </span>
        <br><br>
        <strong>
            二：富美内特梳子为什么那么贵？
        </strong>
        <br><br>
        <span>
            答：产品是专业美容师为祛毛设计的产品，梳齿为特殊不锈钢材料，属专利技术，能够轻松祛除内层脱落和凌乱的毛发。
        </span>
        <br><br>
        <strong>
            三：梳子犬猫可以共用吗？
        </strong>
        <br><br>
        <span>
            答：不建议共用，因为犬猫毛质不同，梳子梳齿间隙不同，不可以共用。
        </span>
        <br><br>
        <strong>
            四：短毛梳子可以梳长毛犬猫吗？
        </strong>
        <br><br>
        <span>
            答：5厘米以下为短毛，5厘米以上为长毛，严选长短毛梳子，才能达到最佳祛毛效果。
        </span>
        <br><br>
        <strong>
            五：高仿梳子和富美内特梳子的区别？
        </strong>
        <br><br>
        <span>
            答：高仿梳子只仿出正品外形，核心参数达不到，且材质低劣，梳齿易变形，容易划伤犬猫皮肤，得不偿失。
        </span>
        <br><br>
        <strong>
            六：怎样区分正品和仿品？
        </strong>
        <br><br>
        <span>
            答：每把正品梳子在梳头部位都有打印独一无二的编码，可通过外包装上电话查询真伪。
        </span>
      </p>
    </div>

        </div>

    <!-- 底部 -->
    <div style="height: 100px;"></div>
  <foot/>

    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
    .w {
  width: 1200px;
  margin: 0 auto;
}

.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-center {
  justify-content: center;
}
.title {
  margin: 20px auto;
  font-size: 20px;
  color: #333;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
}

.desc_container {
  margin-top: 20px;
  padding: 15px 15px;
  background-color: #f8f8f8;
  .article {
    margin: 0;
    padding: 0;
    span {
      font-size: 16px;
      color: #666;
      line-height: 1.75em;
    }
  }
}
</style>